import { Fragment } from 'react'
import { UserAvatarProps } from '../../../models/user-avatar'
import { LuxUserAvatar } from '@lux/wardrobe-lib'
import './UserAvatar.scss'

const UserAvatar = (props: UserAvatarProps) => {
    const { userName, userLastname, userNickname, avatarImage } = props

    const userAvatarClass = 'user-avatar'

    // let userAvatar = (
    //     <Fragment>{`${userName.charAt(0).toUpperCase()}${userLastname
    //         .charAt(0)
    //         .toUpperCase()}`}</Fragment>
    // )

    // if (!!avatarImage) {
    //     userAvatar = (
    //         <Fragment>
    //             <img src={avatarImage} className={`${userAvatarClass}__image`} />
    //         </Fragment>
    //     )
    // }

    // return <div className={userAvatarClass}>{userAvatar}</div>
    return (
        <div className="user-avatar">
            <LuxUserAvatar
                userName={userName || ''}
                userLastname={userLastname || ''}
                userNickname={userNickname}
                avatarImage={avatarImage || ''}
                size={32}
            />
        </div>
    )
}

export default UserAvatar
